import { makeRule } from '@core/utils/rule.js'

export let searchRules = {}

export let formRules = {
  customerid: [
    {required: true, message: '客户ID不能为空', trigger: 'blur'},
  ],
  receipt_info_id: [
    {required: true, message: '抬头不能为空', trigger: 'blur'},
  ],
  desc: [
    {required: true, message: '申请描述不能为空', trigger: 'blur'},
  ],
  type: [
    {required: true, message: '发票类别不能为空', trigger: 'blur'},
  ],
  subject: [
    {required: true, message: '开票主体不能为空', trigger: 'blur'},
  ],
  currency_type: [
    {required: true, message: '币种不能为空', trigger: 'blur'},
  ],
  bd: [
    {required: true, message: '预收款开票 bd 不能为空', trigger: 'blur'},
  ],
  bu_approver: [
    {required: true, message: 'BU审批不能为空', trigger: 'blur'},
  ],
  attached_file: [
    {required: true, message: '附件不能为空', trigger: 'blur'},
  ],
  po_number: [
    {...makeRule('请输入30字以内的单号', 'string', 'blur', false), max: 29},
  ],
  pay_condition_id: [
    {required: true, message: '请选择账期', trigger: 'blur'},
  ],
}

export let assocFormRules = {
  id: [
    {...makeRule('请选择回款', 'integer')},
  ],
  assoc_amount: [
    {...makeRule('请输入回款金额', 'string')},
  ],
}

export let searchManualSaveTicket = {
  fpdm: [
    {required: true, message: '发票代码不能为空', trigger: 'blur'},
  ],
  fphm: [
    {required: true, message: '发票号码不能为空', trigger: 'blur'},
  ],
  kprq: [
    {required: true, message: '开票日期不能为空', trigger: 'blur'},
  ],
}

export let returnForm = {
  isCurrentMonth: [
    {required: true, message: '请选择是否当月发票', trigger: 'blur'},
  ],
  reason: [
    {required: true, message: '退票原因不能为空', trigger: 'blur'},
  ],
  redAttachedFile: [
    {required: true, message: '红冲发票附件不得为空', trigger: 'blur'},
  ],
}

export let completeForm = {
  invoice_number: [
    {required: true, message: '发票号码不能为空', trigger: 'blur'},
    {max: 255, message: '发票号码不得大于255个字符', trigger: 'blur'},
  ],
  invoice_code: [
    {required: true, message: '发票代码不能为空', trigger: 'blur'},
    {max: 255, message: '发票代码不得大于255个字符', trigger: 'blur'},
  ],
  invoice_time: [
    {required: true, message: '开票日期不得为空', trigger: 'blur'},
  ],
  e_invoice_url: [
    {required: true, message: '电子发票链接不得为空', trigger: 'blur'},
  ],
}



// WEBPACK FOOTER //
// ./src/views/invoice-apply/invoice-apply.rules.js